<template>
  <section id="formulario" class="bg-gray-100 py-12">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700">

      <div class="container mx-auto px-4 max-w-7xl">

        <div class="w-full text-center">
          <h1 class="font-bold text-gray-800 md:text-2xl text-lg">Completá tus datos para obtener un QR de acceso al patio comercial.</h1>
          <h1 class="font-bold text-gray-800 mb-2 md:text-lg text-md">El QR es personal e intransferible.</h1>
        </div>

        <div class="w-full text-center mt-5">
          <h1 class="font-bold text-gray-800 mb-4">Por favor completá el formulario en su totalidad</h1>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2">
            <label class="block mb-1">Seleccioná el día</label>
            <Field name="tipoAcreditado" v-slot="{ handleChange, handleBlur, value }" v-model="formData.tipoAcreditado">
              <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccioná el día" class="w-full md:w-14rem p-inputtext-sm" :options="tiposAcreditados" optionLabel="descripcion" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="tipoAcreditado" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Nombre" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="nombre" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Apellido" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/5">
            <label class="block mb-1">DNI</label>
            <Field name="dni" v-slot="{ field }" v-model="formData.dni">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="DNI" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Empresa</label>
            <Field name="empresa" v-slot="{ field }" v-model="formData.empresa">
              <InputText v-bind="field" type="empresa" class="w-full p-inputtext-sm p-3" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" class="w-full p-inputtext-sm p-3" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>          
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">          
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-model="formData.countryCode" class="w-full p-inputtext-sm p-3" readonly />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoArea" v-slot="{ field }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Sin 0 adelante" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="telefonoCelular" v-slot="{ field }" v-model="formData.telefonoCelular">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoCelular" /></span>
            </Field>
          </div>
        </div>

        <h1 class="font-bold text-gray-800 mt-5 text-sm">&bull; RECORDÁ QUE NO ES NECESARIO IMPRIMIR EL TICKET</h1>
        <h1 class="font-bold text-gray-800 text-sm">&bull; ⁠ACCESO UNICAMENTE AL PATIO COMERCIAL ( NO VALIDO PARA CANCHAS CENTRAL, 2 y 3 )</h1>
        <h1 class="font-bold text-gray-800 text-sm">&bull; CON EL REGISTRO DECLARO ACEPTAR LOS SIGUIENTES TÉRMINOS Y CONDICIONES</h1>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit" label="REGISTRARME"
            class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>
    </Form>

  </section>
</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';

import jsonTiposAcreditados from '@/data/tiposAcreditados.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE, VERIFICADO } from "qreventos-suite/constantes";

interface Pais {
  code: string;
  value: string;
}

export default defineComponent({
  name: 'FormSection',
  components: {
    InputText, Dropdown,
    Field, ErrorMessage, Form
  },
  data() {
    return {
      paises: [] as Pais[],
      selectedCountry: { "code": "+54", "value": "Argentina" } as Pais,
      isSubmitting: false,
      tiposAcreditados: [] as TipoAcreditado[],
      formData: {
        dni: '',
        nombre: '',
        apellido: '',
        telefonoCelular: '',
        codigoArea: '',
        mail: '',
        empresa: '',
        countryCode: '+54',
        tipoAcreditado: undefined as unknown as TipoAcreditado,
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required('Ingresá el DNI').min(8, 'Al menos 8 números'),
        nombre: yup.string().required('Ingresá el nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingresá el apellido').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingresá el correo').email('Correo inválido'),
        empresa: yup.string().required('Ingresá la empresa').min(2, 'Al menos 3 letras'),
        telefonoCelular: yup.string().required('Ingresá el celular').matches(/^\d+$/, 'Solo se permiten números'),
        codigoArea: yup.string().required('Ingresá el código de área').matches(/^\d+$/, 'Solo se permiten números'),
        tipoAcreditado: yup.mixed().required('Seleccioná el día que deseas asistir'),
      });
    }
  },
  methods: {
    async onSubmit() {

      this.isSubmitting = true;

      try {
        let acreditado: Acreditado = new Object() as Acreditado;
        acreditado.tipoAcreditado = { "id": this.formData.tipoAcreditado.id } as TipoAcreditado;
        acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
        acreditado.nombre = this.formData.nombre;
        acreditado.apellido = this.formData.apellido;
        acreditado.telefono = this.selectedCountry.code + this.formData.codigoArea + this.formData.telefonoCelular;
        acreditado.mail = this.formData.mail;
        acreditado.empresa = this.formData.empresa;
        acreditado.modificado = SAVE;
        acreditado.cantidad = 1;
        acreditado.notificar = true;

        acreditado.datos = {} as any;
        acreditado.datos["3868"] = this.formData.dni;

        let responseData:Acreditado = await suiteService.saveOrUpdate(suiteConfig.evento, suiteConfig.token, acreditado);

        responseData = await suiteService.findAcreditadoByFilters(suiteConfig.evento, suiteConfig.token, "codigo_acreditado=" + responseData.codigoAcreditado );

        Swal.fire({
          title: "Acreditación exitosa",
          html: "Hemos recibido tus datos de acreditación con éxito.<br/>Te enviamos tu credencial al mail indicado.<br><img style='display: block; margin: auto;'  src='https://apps.qreventos.com/qr/generateQr?hexColor=000000&size=250&text=" + responseData.codigoAcreditado + "'/><br>También podés descargar tu acceso haciendo click en el botón debajo. ",
          icon: "success",
          confirmButtonText: 'DESCARGAR CREDENCIAL',
        }).then(() => {
          window.location.href = "https://apps.qreventos.com/credencial/getCredencial?credencial=151&evento=348&pdf=true&hash=" + responseData.hash;
        });

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    }
  },
  async mounted() {
    this.tiposAcreditados = jsonTiposAcreditados;
  }
});
</script>
